module.exports = __webpack_public_path__ + "static/media/baustelle.41cc4a74.svg";